<template>
  <div class="order_detail">
    <div class="order_detail_nav">
      <navbar
        title="订单详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row>
        <van-col span="24" class="status"> {{ statusTit }}</van-col>
        <van-col span="24" class="tip"> {{ statusTip }}</van-col>
      </van-row>
      <van-row>
        <van-col
          span="24"
          class="show_address"
          v-if="detailInfo.delivery_address"
        >
          <span class="address">
            <img src="../../../assets/accountAgent/common/address.png" alt="" />
          </span>
          <p class="name">
            {{ detailInfo.delivery_address.consignee
            }}<span>{{ detailInfo.delivery_address.consignee_mobile }}</span>
          </p>
          <p class="site">
            {{
              detailInfo.delivery_address.address_name +
              detailInfo.delivery_address.address
            }}
          </p>
        </van-col>
      </van-row>
      <!-- <div class="profit">
        <van-row class="title">
          <van-col span="24" @click="changeDetailShow">
            红包补贴金额已累计：¥1012.00
            <van-icon name="arrow-down" v-if="!detailShow" />
            <van-icon name="arrow-up" v-if="detailShow" />
          </van-col>
        </van-row>
        <div v-if="detailShow">
          <van-row class="tab">
            <van-col span="12">补贴时间</van-col>
            <van-col span="12">红包补贴金额</van-col>
          </van-row>
          <van-row class="item">
            <van-col span="12">2021-10-09 10:09:08</van-col>
            <van-col span="12" class="money">+ 1200.00</van-col>
          </van-row>
          <van-row class="item">
            <van-col span="12">2021-10-09 10:09:08</van-col>
            <van-col span="12" class="money">+ 1200.00</van-col>
          </van-row>
        </div>
      </div> -->
      <van-row class="phone_info">
        <van-col span="24" class="num">
          认领手机数量<span>共1台</span>
        </van-col>
        <van-col span="24" class="price">
          订单总价<span>2000.00</span>
        </van-col>
        <van-col span="24" class="pay">
          实付金额：
          <span class="money">
            ￥<span class="num">2000<span>.00</span></span>
          </span>
        </van-col>
      </van-row>

      <van-row class="order_info">
        <van-col span="24" class="title">订单信息</van-col>
        <van-col span="24" class="item">
          <span class="label">订单编号：</span>
          <span class="_copy" ref="copytxt1">{{ detailInfo.ordersn }}</span>
          <span class="copy" @click="copyCode(1)">复制</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.post_name">
          <span class="label">物流公司：</span>
          <span>{{ detailInfo.post_name }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.post_no">
          <span class="label">物流编号：</span>
          <span class="_copy" ref="copytxt2">{{ detailInfo.post_no }}</span>
          <span class="copy" @click="copyCode(2)">复制</span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">下单时间：</span>
          <span>{{ detailInfo.created_at }}</span>
        </van-col>
        <van-col
          span="24"
          class="item"
          v-if="detailInfo.status == -10 || detailInfo.status == -20"
        >
          <span class="label">取消时间：</span>
          <span>{{ detailInfo.updated_at }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.pay_time">
          <span class="label">支付时间：</span>
          <span>{{ detailInfo.pay_time }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.confirm_time">
          <span class="label">收货时间：</span>
          <span>{{ detailInfo.confirm_time }}</span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">购买会员：</span>
          <span> {{ detailInfo.user_name }} </span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">会员手机号：</span>
          <span>{{ detailInfo.user_mobile }}</span>
        </van-col>
      </van-row>
    </div>
    <van-row class="order_detail_footer">
      <van-col span="24">
        <btn
          :btntext="'取消订单'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 10"
          @btnClick="cancle()"
        />
        <btn
          :btntext="'申请退款'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 15 || detailInfo.status == 20"
          @btnClick="refund()"
        />
        <btn
          :btntext="'查看协议'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status > 20"
          @btnClick="seeSinature()"
        />
        <btn
          :btntext="'联系客服'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          @btnClick="contract"
        />
        <btn
          :btntext="'申请退还'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 40 || detailInfo.status == 50"
          @btnClick="refundPhone()"
        />
        <!-- <btn
          :btntext="'删除订单'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == -10 || detailInfo.status == -20"
          @btnClick="delect()"
        /> -->
        <btn
          :btntext="'立即付款'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#F9591B'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #F9591B'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 10"
          @btnClick="Pay()"
        />
        <btn
          :btntext="'去签署'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#F9591B'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #F9591B'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 15 || detailInfo.status == 20"
          @btnClick="toSign()"
        />
        <btn
          :btntext="'确认收货'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#F9591B'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #F9591B'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 30"
          @btnClick="settle()"
        />
      </van-col>
    </van-row>
    <a ref="phone" href="tel:4000571671"></a>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import dsbridge from "dsbridge";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailShow: false,
      statusTit: "",
      statusTip: "",
      detailInfo: {},
      facility: "",
      timer: "",
    };
  },
  created() {
    //ordersn 非售后订单
    this.getInfo();
  },
  mounted() {
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
    getInfo() {
      this.$api
        .post("/investment/member/agent/order/detail", {
          ordersn: this.$route.query.ordersn,
        })
        .then((res) => {
          res.delivery_address = JSON.parse(res.delivery_address);
          this.detailInfo = res;
          if (res.status == 10) {
            //待支付
            this.statusTit = "等待买家付款";
            res.created_at = res.created_at.replace(/-/g, "/");
            let end_time =
              Math.floor(new Date(res.created_at).getTime() / 1000) + 30 * 60;
            this.setTimer(end_time);
          } else if (res.status == 15 || res.status == 20) {
            //支付中 待签署合同
            this.statusTit = "等待买家签署合同";
            this.statusTip = "订单已支付，等待签署三方合同";
          } else if (res.status == 25 || res.status == 28) {
            //合同审核中 待发货
            this.statusTit = "等待卖家发货";
            this.statusTip = "订单已支付，等待卖家发货";
          } else if (res.status == 30) {
            //待收货
            this.statusTit = "等待收货";
            this.statusTip = "卖家已发货，请耐心等待...";
          } else if (res.status == 40 || res.status == 50) {
            //已收货 已完成
            this.statusTit = "订单已完成";
            this.statusTip = "感谢您对销巴的支持！";
          } else if (res.status == -10 || res.status == -20) {
            //已取消
            this.statusTit = "订单已取消";
            this.statusTip = "感谢您对销巴的支持！";
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    setTimer(end_time) {
      var _that = this;
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = end_time - current;
      if (ts <= 0) {
        this.statusTip = "剩00分00秒自动关闭";
        clearInterval(this.timer);
        return false;
      } else {
        _that.getTimeCount(ts, _that);
      }
      this.timer = setInterval(function () {
        var current = Math.floor(new Date().getTime() / 1000);
        var ts = end_time - current;
        if (ts <= 0) {
          clearInterval(this.timer);
          _that.getInfo();
        } else {
          _that.getTimeCount(ts, _that);
        }
      }, 1000);
    },
    //支付时间倒计时
    getTimeCount(ts, _that) {
      var mm = parseInt((ts / 60) % 60, 10);
      var ss = parseInt(ts % 60, 10);
      this.statusTip =
        "剩" + _that.checkTime(mm) + "分" + _that.checkTime(ss) + "秒自动关闭";
    },
    changeDetailShow() {
      this.detailShow = !this.detailShow;
    },

    cancle() {
      this.$dialog
        .confirm({
          message: "您确定要取消该订单？",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "再想想",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("/order/member/order/cancel", {
              ordersn: this.detailInfo.ordersn,
            })
            .then((res) => {
              clearInterval(this.timer);
              setTimeout(() => {
                this.getInfo();
              }, 1000);
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        });
    },
    contract() {
      this.$dialog
        .confirm({
          message: "4000571671",
          confirmButtonText: "立即呼叫",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          // this.$refs.phone.click();
          // this.params("4000571671", "4000571671", "contract");
          let ua = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod|macintosh/i.test(ua) &&
            !this.$route.query.from
          ) {
            this.params("4000571671", "4000571671", "contract");
          } else {
            this.$refs.phone.click();
          }
        });
    },
    Pay() {
      sessionStorage.setItem("currentOrderSn", this.detailInfo.ordersn);
      let param = {
        actual_amount: this.detailInfo.amount,
        order_amount: this.detailInfo.amount,
        ordersn: this.detailInfo.ordersn,
        order_type: "surrogacy",
      };
      if (this.facility == "ios") {
        let that = this;
        dsbridge.call("goPay", JSON.stringify(param), function (v) {
          that.setPay(v);
        });
      } else if (this.facility == "android") {
        this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$router.push({
          //支付成功
          path: "/accountAgent/result",
          query: {
            type: 1,
            ordersn: sessionStorage.getItem("currentOrderSn"),
          },
        });
      }
      // else {
      //   this.$router.push({
      //     //支付失败
      //     path: "/accountAgent/detail",
      //     query: {
      //       ordersn: sessionStorage.getItem("currentOrderSn"),
      //       from: "pay",
      //     },
      //   });
      // }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    refund() {
      this.$dialog
        .confirm({
          message: "您确定要申请退款？",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("/investment/member/agent/order/after/add", {
              ordersn: this.detailInfo.ordersn,
            })
            .then((res) => {
              this.$toast("退款申请已提交成功");
              this.getInfo();
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
              return;
            });
        });
    },
    refundPhone() {
      this.$router.push({
        path: "/accountAgent/refund",
        query: {
          ordersn: this.detailInfo.ordersn,
        },
      });
    },
    toSign() {
      this.$router.push({
        path: "/accountAgent/signContract",
        query: {
          from: "h5",
          ordersn: this.detailInfo.ordersn,
        },
      });
    },
    seeSinature() {
      this.$router.push({
        path: "/accountAgent/electroniContract",
        query: {
          ordersn: this.detailInfo.ordersn,
        },
      });
    },
    settle() {
      this.$api
        .post("/order/member/order/settle", {
          ordersn: this.detailInfo.ordersn,
        })
        .then((res) => {
          setTimeout(() => {
            this.getInfo();
          }, 1000);
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      if (index == 1) {
        rechage_range.selectNode(this.$refs.copytxt1);
      } else {
        rechage_range.selectNode(this.$refs.copytxt2);
      }
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
  },
};
</script>
<style lang="less" scoped>
.order_detail {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_detail_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 6.5rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .status {
      color: #333;
      font-size: 1.8rem;
      padding-left: 1.2rem;
      height: 2.9rem;
      line-height: 2.9rem;
    }

    .tip {
      color: #666;
      font-size: 1.4rem;
      padding: 0 1.2rem;
      margin: 0.2rem 0 1.2rem;
      line-height: 2.3rem;
    }

    .show_address {
      min-height: 8.5rem;
      padding: 1.5rem 1rem 1.5rem 5.1rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      text-align: left;
      position: relative;
      box-sizing: border-box;

      .address {
        width: 5.1rem;
        padding-left: 1rem;
        min-height: 8.5rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        img {
          width: 2.6rem;
        }
      }

      .name {
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        height: 2.6rem;
        line-height: 2.6rem;
        margin-bottom: 0.6rem;

        span {
          margin-left: 3rem;
        }
      }

      .site {
        color: #999;
        font-size: 1.4rem;
        line-height: 2.3rem;
      }
    }

    .profit {
      display: none;
      min-height: 5.6rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.5rem 0.6rem 0.3rem;
      font-size: 1.4rem;
      box-sizing: border-box;
      margin-bottom: 1rem;

      .title {
        color: #f9591b;
        font-size: 1.5rem;
        height: 2.6rem;
        line-height: 2.6rem;
        padding: 0 0.6rem;

        .van-icon {
          color: #999;
          float: right;
          margin-top: 0.5rem;
        }
      }

      .tab {
        color: #333;
        margin-top: 1.5rem;
        background: #f5f6f7;
        height: 2.9rem;
        line-height: 2.9rem;
        text-align: center;
      }

      .item {
        color: #999;
        text-align: center;
        height: 5rem;
        line-height: 5rem;

        .money {
          color: #f9591b;
        }
      }
    }

    .phone_info {
      height: 12.5rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.2rem;
      color: #333;
      font-size: 1.4rem;
      box-sizing: border-box;
      margin-bottom: 1rem;

      .num {
        color: #333;
        height: 2.4rem;
        line-height: 2.4rem;

        span {
          float: right;
        }
      }

      .price {
        color: #999;
        height: 2.3rem;
        line-height: 2.3rem;
        margin-top: 1.2rem;

        span {
          color: #333;
          float: right;
        }
      }

      .pay {
        color: #333;
        text-align: right;
        margin-top: 1.2rem;

        .money {
          font-size: 1.3rem;
          font-weight: 700;
          margin-left: 0.2rem;

          .num {
            font-size: 2.2rem;

            span {
              font-size: 1.6rem;
            }
          }
        }
      }
    }

    .order_info {
      height: auto;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.2rem 1.2rem 1.5rem;
      color: #333;
      font-size: 1.3rem;
      box-sizing: border-box;

      .title {
        font-size: 1.4rem;
        font-weight: 700;
        height: 2.4rem;
        line-height: 2.4rem;
      }

      .item {
        line-height: 1.4rem;
        margin-top: 1.6rem;

        span {
          float: left;
          width: calc(100% - 9.3rem);
        }

        ._copy {
          width: calc(100% - 16.7rem);
        }

        .label {
          color: #999;
          width: 9.3rem;
        }

        .copy {
          float: right;
          color: #f9591b;
          width: 5rem;
          height: 2.3rem;
          line-height: 2.3rem;
          text-align: center;
          border-radius: 0.2rem;
          border: solid 0.1rem #f9591b;
          margin-top: -0.5rem;
        }
      }
    }
  }

  .order_detail_footer {
    height: 5rem;
    padding: 0.7rem 1.2rem 0;
    background: #fff;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
<style lang="less">
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>